<flex-column adEl>
  <div adEl="scrollContainer" #scrollContainer grow scroll>
    <nav adEl class="top">
      <div adEl class="nav-in">
        <a adEl="brand" class="brand" routerLink="/">
          <div adEl class="brand-mark">
            <apex-logo adEl></apex-logo>
          </div>
          <div adEl class="brand-text">Apex Process Consultants</div>
        </a>
        <div adEl class="nav-links">
          <a
            adEl="consultingLink"
            routerLink="/consulting"
            routerLinkActive="active"
            >Consulting</a
          >
          <a
            adEl="platformLink"
            routerLink="/platform"
            routerLinkActive="active"
            >Platform</a
          >
          <a
            adEl="fieldNotesLink"
            routerLink="/field-notes"
            routerLinkActive="active"
            >Field Notes</a
          >
          <a adEl="contactLink" routerLink="/contact" routerLinkActive="active"
            >Contact</a
          >
        </div>
        <a
          adEl="bookCta"
          class="btn"
          routerLink="/contact"
          (click)="analyticsService.trackBookCta('nav')"
        >
          <span adEl="label">Book 30 min</span>
          <span adEl="arr" class="arr">→</span>
        </a>
        <button
          adEl="navBurger"
          class="nav-burger"
          type="button"
          aria-label="Toggle menu"
          [aria-expanded]="mobileMenuOpen"
          (click)="toggleMobileMenu()"
        >
          {{mobileMenuOpen ? '✕' : '☰'}}
        </button>
      </div>
      <div
        adEl="mobileMenu"
        [class]="mobileMenuOpen ? 'nav-mobile open' : 'nav-mobile'"
      >
        <div adEl class="nav-mobile-in">
          <a
            adEl="mobileConsulting"
            routerLink="/consulting"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
            >Consulting</a
          >
          <a
            adEl="mobilePlatform"
            routerLink="/platform"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
            >Platform</a
          >
          <a
            adEl="mobileFieldNotes"
            routerLink="/field-notes"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
            >Field Notes</a
          >
          <a
            adEl="mobileContact"
            routerLink="/contact"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
            >Contact</a
          >
          <a
            adEl="mobileBook"
            class="btn accent"
            routerLink="/contact"
            (click)="bookFromMobileNav()"
          >
            <span adEl="label">Book 30 min</span>
            <span adEl="arr" class="arr">→</span>
          </a>
        </div>
      </div>
    </nav>
    <router-outlet
      adEl
      (activate)="scrollContainer.scrollTo(0, 0)"
    ></router-outlet>
    <site-footer adEl></site-footer>
  </div>
</flex-column>
